// extracted by mini-css-extract-plugin
export default {"root":"CtaSection_root-zcp","card":"CtaSection_card-zoT","title":"CtaSection_title-V_t","subtitle":"CtaSection_subtitle-nT6"};